import { LocalScanningWebApiService } from '../../services/local-scanning-web-api.service';
import { SessionActions, SessionsFetchError, SessionsReceived } from './session.actions';
import { Observable, of } from 'rxjs';
import { Action, Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { inject, Injectable } from '@angular/core';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable()
export class SessionEffects {
  private actions$ = inject(Actions);
  private store$ = inject<Store<any>>(Store);
  private webapi = inject(LocalScanningWebApiService);

  sessionsFetch$: Observable<Action> = createEffect(() => this.actions$
    .pipe(
      ofType(SessionActions.SESSIONS_FETCH),
      switchMap((/* action: SessionsFetch */) => {
        return this.webapi.getUnsubmittedSessions()
          .pipe(
            catchError((e) => {
              // catch here; a catch on the main observable chain
              // would "complete" the observable and unsubscribe the effect
              return of(new SessionsFetchError(e));
            })
          );
      }),
      switchMap((result: any) => {
        if (result.type === SessionActions.SESSIONS_FETCH_ERROR) {
          return of(result);
        } 
        return of(new SessionsReceived(result));
      })
    ));
}
